"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InactivityHandler {
    constructor(timeout, onTimedOut) {
        this.start = () => {
            this.reset();
        };
        this.stop = () => {
            if (this.timerHandle) {
                clearTimeout(this.timerHandle);
                this.timerHandle = undefined;
            }
        };
        this.reset = () => {
            if (this.timerHandle) {
                clearTimeout(this.timerHandle);
                this.timerHandle = undefined;
            }
            this.timerHandle = setTimeout(() => {
                this.onTimedOut(this);
            }, this.timeout);
        };
        this.timeout = timeout;
        this.onTimedOut = onTimedOut;
    }
}
exports.default = InactivityHandler;
//# sourceMappingURL=InactivityHandler.js.map